export default __webpack_public_path__ + "static/media/oba.172e3608.jpg";